import './style.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';
import { ProductsSection } from './components/Products.js';
import { TestimonialsSection } from './components/Testimonials.js';
import { NewsletterSection } from './components/Newsletter.js';
import { FooterSection } from './components/Footer.js';
import { FeaturesSection } from './components/Features.js';

function initApp() {
  const app = document.getElementById('app');
  if (!app) return;

  // Pre-initialize AOS
  AOS.init({
    disable: true // temporarily disable
  });

  // Set content
  app.innerHTML = `
    <header class="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-sm">
      <nav class="container mx-auto px-6 py-4 flex justify-between items-center">
        <div class="flex items-center">
          <img src="https://farskapet.no/cdn/shop/files/Farskapet_logo.png?v=1736269950&width=380" 
               alt="Farskapet" 
               class="h-12">
        </div>
        <div class="flex items-center">
          <a href="https://farskapet.no/collections/all?utm_source=landing_page&utm_medium=header_button&utm_campaign=sagababy_products" 
             target="_blank"
             class="shine-button px-8 py-3 rounded-lg text-white font-semibold"
             data-aos="fade-left">
            Bestill Produkter
          </a>
        </div>
      </nav>
    </header>
    <main>
      <section class="hero-section flex items-center relative pt-24 pb-12 parallax">
        <div class="container mx-auto px-6">
          <div class="text-center max-w-4xl mx-auto mb-12 parallax-content" data-aos="fade-up">
            <span class="inline-block px-4 py-2 bg-secondary/20 rounded-full text-sm mb-4">
              ✨ Sagababy Produkter
            </span>
            <h1 class="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
              Gjør hverdagen enklere med Sagababy
            </h1>
            <p class="text-xl mb-8 text-gray-700">
              Praktiske og sammenleggbare produkter for aktive familier
            </p>
            <a href="#products" 
               class="shine-button text-lg px-8 py-4 rounded-lg inline-flex items-center gap-2 text-white">
              Se Alle Produkter
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div class="floating-badge badge-1" data-aos="fade-right">
          <div class="flex items-center gap-2">
            <span class="text-xl">★</span>
            <div>
              <p class="font-bold">5.0 Kundevurdering</p>
            </div>
          </div>
        </div>
        
        <div class="floating-badge badge-2" data-aos="fade-left">
          <div class="flex items-center gap-2">
            <span class="text-xl">🚚</span>
            <div>
              <p class="font-bold">Rask Levering</p>
              <p class="text-sm text-gray-600">2-4 dagers leveringstid</p>
            </div>
          </div>
        </div>
      </section>

      ${FeaturesSection()}
      ${ProductsSection()}
      ${TestimonialsSection()}
      ${NewsletterSection()}
      ${FooterSection()}
    </main>
  `;

  // Re-initialize AOS with proper settings
  AOS.init({
    duration: 1000,
    once: true,
    offset: 50,
    mirror: true,
    anchorPlacement: 'top-bottom',
    disable: false
  });

  // Initialize Swiper
  const swiperElement = document.querySelector('.testimonial-swiper');
  if (swiperElement) {
    new Swiper(swiperElement, {
      modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      }
    });
  }
}

// Use both DOMContentLoaded and load events
document.addEventListener('DOMContentLoaded', initApp);
window.addEventListener('load', initApp);